/** Libro de ventas: solo facturas con `venta_completada` (no pedidos abiertos, no tabla `ventas`). */
export function facturaCuentaComoVendida(row: {
  estado?: string | null;
  estado_pago?: string | null;
  venta_completada?: boolean | null;
}): boolean {
  const est = String(row.estado || '').toUpperCase();
  if (est === 'ANULADA' || est === 'ELIMINADA' || est === 'CANCELADO') return false;
  if (String(row.estado_pago || '').toUpperCase() === 'CANCELADO') return false;
  return Boolean(row.venta_completada);
}
